/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CouponTypeApiModel } from './coupon-type';
import { BenefitsChargeTypeExtendedApiModel } from './benefits-charge-type-extended';
import { PromotionalBonusesExpireTypeBaseApiModel } from './promotional-bonuses-expire-type-base';
import { BenefitsPriceTypeApiModel } from './benefits-price-type';
import { CouponBatchLinkApiModel } from './coupon-batch-link';
import { CouponBatchAliasApiModel } from './coupon-batch-alias';

export interface CouponBatchApiModel {
  /**
   * Coupons active flag
   */
  active?: number | null;
  alias?: CouponBatchAliasApiModel;
  /**
   * Business code
   */
  business_code?: string | null;
  /**
   * Coupon batch code
   */
  code?: string | null;
  /**
   * Coupon emission price (optional)
   */
  customers_price_amount?: number | null;
  /**
   * Coupon emission price currency (optional)
   */
  customers_price_currency?: string | null;
  /**
   * Coupon emission price special account Id (optional)
   */
  customers_price_special_account_id?: string | null;
  /**
   * Coupon emission price special account title (optional)
   */
  customers_price_special_account_title?: string | null;
  customers_price_type?: BenefitsPriceTypeApiModel;
  /**
   * Coupons batch description
   */
  description?: string | null;
  /**
   * Date of emission begins
   */
  emission_period_begin?: string | null;
  /**
   * Date of emission ends
   */
  emission_period_end?: string | null;
  /**
   * External code visibility type
   */
  external_code_visibility_type?: CouponBatchApiModelExternalCodeVisibilityTypeEnum | null;
  /**
   * Unique id of coupon batch
   */
  id?: string | null;
  image?: string | null;
  links?: Array<CouponBatchLinkApiModel>;
  /**
   * Loyalty emission id
   */
  loyalty_id?: string | null;
  /**
   * Coupons batch public description (optional, same as description)
   */
  public_description?: string | null;
  /**
   * Coupons batch public title (optional, same as title)
   */
  public_title?: string | null;
  /**
   * Recommendation fee amount (optional)
   */
  recommendation_fee_amount?: number | null;
  /**
   * Recommendation fee bonuses currence ISO code (optional)
   */
  recommendation_fee_bonuses_currency?: string | null;
  /**
   * Recommendation fee Batch CODE (optional)
   */
  recommendation_fee_coupon_batch_code?: string | null;
  /**
   * Recommendation fee Batch Id (optional)
   */
  recommendation_fee_coupon_batch_id?: string | null;
  /**
   * Recommendation fee Batch TITLE (optional)
   */
  recommendation_fee_coupon_batch_title?: string | null;
  /**
   * Value of recommendation fee promotional bonuses expire date (optional)
   */
  recommendation_fee_promotional_bonuses_expire_date?: string | null;
  recommendation_fee_promotional_bonuses_expire_type?: PromotionalBonusesExpireTypeBaseApiModel;
  /**
   * Value of recommendation fee promotional bonuses expire (optional)
   */
  recommendation_fee_promotional_bonuses_expire_value?: number | null;
  /**
   * Recommendation fee special account Id (optional)
   */
  recommendation_fee_special_account_id?: string | null;
  /**
   * Recommendation fee special account title (optional)
   */
  recommendation_fee_special_account_title?: string | null;
  recommendation_fee_type?: BenefitsChargeTypeExtendedApiModel;
  /**
   * Redeem only at terminal restriction
   */
  redeem_at_terminal?: number | null;
  /**
   * Coupons share allowed for customer
   */
  share_allowed?: number | null;
  /**
   * Coupons batch title
   */
  title?: string | null;
  type?: CouponTypeApiModel;
}
export enum CouponBatchApiModelExternalCodeVisibilityTypeEnum {
  AlwaysOpen = 'always-open',
  OnRedeem = 'on-redeem'
}
